export const HalfHorizontal = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="18" height="18" rx="3.5" stroke="black" />
      <line x1="9.5" y1="19" x2="9.5" y2="1.72545e-08" stroke="black" />
    </svg>
  );
};
